<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="active-book-modal"
    width="520px"
    center
    @closed="cancel"
  >
    <p class="title">
      您即将激活
      {{ book_title }}
      。请轻轻刮开图书封底圆形贴纸的涂层，输入涂层下面的激活码：
    </p>
    <el-row class="input">
      <el-col :span="6" class="label">激活码：</el-col>
      <el-col :span="14">
        <el-input v-model="activation_code"></el-input>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { activeBookDB } from "@/interface";
export default {
  data() {
    return {
      visible: false,
      book_id: null,
      book_title: null,
      activation_code: "",
    };
  },
  methods: {
    openModal(obj) {
      const { book_id, book_title } = obj;
      this.book_id = book_id;
      this.book_title = book_title;
      this.visible = true;
    },
    cancel() {
      this.book_id = null;
      this.book_title = null;
      this.activation_code = "";
      this.visible = false;
    },
    save() {
      if (!this.activation_code) return this.$message.error("请填写激活码");
      const params = {
        book_id: this.book_id,
        activation_code: this.activation_code,
      };

      activeBookDB(params).then((res) => {
        this.$message.success("激活成功");
        this.$emit("submitPopupData");
        this.book_id = null;
        this.book_title = null;
        this.activation_code = "";
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.active-book-modal {
  .title {
    font-size: 16px;
    line-height: 1.5em;
    padding: 0 20px;
  }
  .input {
    margin-top: 20px;
    .label {
      color: #666;
      line-height: 38px;
      text-align: right;
    }
  }
}
</style>
